export default "__VITE_ASSET__7e86f653__"